module.exports = __webpack_public_path__ + "02_very_short_black.de5844bb.png";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/custom/momoro/girl/layer5/02_very_short_black.png
// module id = fzBC
// module chunks = 0